var _path, _path2, _path3, _path4, _path5, _path6, _path7, _rect, _path8, _path9, _path10, _path11, _path12, _path13, _path14;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMultiCalendar = function SvgMultiCalendar(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 5.5C1 4.11929 2.11929 3 3.5 3H20.5C21.8807 3 23 4.11929 23 5.5V20.5C23 21.8807 21.8807 23 20.5 23H3.5C2.11929 23 1 21.8807 1 20.5V5.5ZM3.5 5C3.22386 5 3 5.22386 3 5.5V20.5C3 20.7761 3.22386 21 3.5 21H20.5C20.7761 21 21 20.7761 21 20.5V5.5C21 5.22386 20.7761 5 20.5 5H3.5Z",
    fill: "#082244"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 1C8.05228 1 8.5 1.44772 8.5 2V6C8.5 6.55228 8.05228 7 7.5 7C6.94772 7 6.5 6.55228 6.5 6V2C6.5 1.44772 6.94772 1 7.5 1Z",
    fill: "#082244"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5 1C17.0523 1 17.5 1.44772 17.5 2V6C17.5 6.55228 17.0523 7 16.5 7C15.9477 7 15.5 6.55228 15.5 6V2C15.5 1.44772 15.9477 1 16.5 1Z",
    fill: "#082244"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 13C12.8284 13 13.5 12.3284 13.5 11.5C13.5 10.6716 12.8284 10 12 10C11.1716 10 10.5 10.6716 10.5 11.5C10.5 12.3284 11.1716 13 12 13Z",
    fill: "#082244"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5 13C18.3284 13 19 12.3284 19 11.5C19 10.6716 18.3284 10 17.5 10C16.6716 10 16 10.6716 16 11.5C16 12.3284 16.6716 13 17.5 13Z",
    fill: "#082244"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5 18.5C7.32843 18.5 8 17.8284 8 17C8 16.1716 7.32843 15.5 6.5 15.5C5.67157 15.5 5 16.1716 5 17C5 17.8284 5.67157 18.5 6.5 18.5Z",
    fill: "#082244"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 18.5C12.8284 18.5 13.5 17.8284 13.5 17C13.5 16.1716 12.8284 15.5 12 15.5C11.1716 15.5 10.5 16.1716 10.5 17C10.5 17.8284 11.1716 18.5 12 18.5Z",
    fill: "#082244"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 9,
    width: 18,
    height: 20,
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 11.5C7 10.1193 8.11929 9 9.5 9H26.5C27.8807 9 29 10.1193 29 11.5V26.5C29 27.8807 27.8807 29 26.5 29H9.5C8.11929 29 7 27.8807 7 26.5V11.5ZM9.5 11C9.22386 11 9 11.2239 9 11.5V26.5C9 26.7761 9.22386 27 9.5 27H26.5C26.7761 27 27 26.7761 27 26.5V11.5C27 11.2239 26.7761 11 26.5 11H9.5Z",
    fill: "#082244"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5 7C14.0523 7 14.5 7.44772 14.5 8V12C14.5 12.5523 14.0523 13 13.5 13C12.9477 13 12.5 12.5523 12.5 12V8C12.5 7.44772 12.9477 7 13.5 7Z",
    fill: "#082244"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5 7C23.0523 7 23.5 7.44772 23.5 8V12C23.5 12.5523 23.0523 13 22.5 13C21.9477 13 21.5 12.5523 21.5 12V8C21.5 7.44772 21.9477 7 22.5 7Z",
    fill: "#082244"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 19C18.8284 19 19.5 18.3284 19.5 17.5C19.5 16.6716 18.8284 16 18 16C17.1716 16 16.5 16.6716 16.5 17.5C16.5 18.3284 17.1716 19 18 19Z",
    fill: "#082244"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5 19C24.3284 19 25 18.3284 25 17.5C25 16.6716 24.3284 16 23.5 16C22.6716 16 22 16.6716 22 17.5C22 18.3284 22.6716 19 23.5 19Z",
    fill: "#082244"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 24.5C13.3284 24.5 14 23.8284 14 23C14 22.1716 13.3284 21.5 12.5 21.5C11.6716 21.5 11 22.1716 11 23C11 23.8284 11.6716 24.5 12.5 24.5Z",
    fill: "#082244"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 24.5C18.8284 24.5 19.5 23.8284 19.5 23C19.5 22.1716 18.8284 21.5 18 21.5C17.1716 21.5 16.5 22.1716 16.5 23C16.5 23.8284 17.1716 24.5 18 24.5Z",
    fill: "#082244"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMultiCalendar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/multi-calendar.8a5d5aca.svg";
export { ForwardRef as ReactComponent };